<!-- InstructionModal.vue -->
<template>
    <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50" v-if="isOpen">
      <div class="bg-white rounded-lg shadow-lg p-6 max-w-lg w-full">
        <div class="flex justify-between items-center border-b pb-3">
          <h3 class="text-lg font-semibold text-primary-400">Instructions</h3>
          <button @click="closeModal" class="text-gray-400 hover:text-gray-600">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        <div class="mt-4 text-gray-700" v-html="content[currentStep]"></div>
        <div class="mt-6 flex justify-end">
          <button v-if="currentStep > 0" @click="prevStep" class="px-4 py-2 bg-primary-400 text-white rounded-lg hover:bg-primary-500 mr-2">
            Previous
          </button>
          <button v-if="currentStep < content.length - 1" @click="nextStep" class="px-4 py-2 bg-primary-400 text-white rounded-lg hover:bg-primary-500">
            Next
          </button>
          <button v-else @click="closeModal" class="px-4 py-2 bg-primary-400 text-white rounded-lg hover:bg-primary-500">
            Close
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      isOpen: {
        type: Boolean,
        required: true
      },
      content: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        currentStep: 0
      };
    },
    methods: {
      closeModal() {
        this.$emit('close');
        this.currentStep = 0;
      },
      nextStep() {
        this.currentStep++;
      },
      prevStep() {
        this.currentStep--;
      }
    }
  }
  </script>
  
  <style scoped>
  /* Add your styles here if needed */
  </style>
  